import React, { useState } from "react";
import Dashboard from "./Dashboard";
import SbtDashboard from "./dashboards/SbtDashboard";
import CreateSbtAuthDashboard from "./dashboards/CreateSbtAuthDashboard";
import CreateSbtDashboard from "./dashboards/CreateSbtDashboard";
import SbtConsentDashboard from "./dashboards/SbtConsentDashboard";
import SbtAuthDashboard from "./dashboards/SbtAuthDashboard";
import MarketplaceListDashboard from "./dashboards/MarketplaceListDashboard";
import MarketplaceOfferDashboard from "./dashboards/MarketplaceOfferDashboard";
import MarketplaceGrantDashboard from "./dashboards/MarketplaceGrantDashboard";

import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import TokenIcon from "@mui/icons-material/Token";
import LockIcon from "@mui/icons-material/Lock";
import AddBoxIcon from "@mui/icons-material/AddBox";
import CleanHandsIcon from "@mui/icons-material/CleanHands";
import EnhancedEncryptionIcon from "@mui/icons-material/EnhancedEncryption";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';

import useEnv from "./hooks/envHook";
import useNear from "./hooks/nearHook";

import { useRoutes, Navigate, useNavigate } from "react-router-dom";

// TODO: use routes
const listItems = [
  {
    icon: <TokenIcon />,
    menuTitle: "SBTs",
    title: `My Soul Bound Tokens`,
    component: <SbtDashboard />,
    route: "sbt",
  },
  {
    icon: <AddBoxIcon />,
    menuTitle: "Create SBTs",
    title: `Create Soul Bound Tokens`,
    component: <CreateSbtDashboard />,
    route: "sbt-create",
  },
  {
    icon: <CleanHandsIcon />,
    menuTitle: "SBT Consent",
    title: `Manage Soul Bound Token consents`,
    component: <SbtConsentDashboard />,
    route: "sbt-consent",
  },
  {
    icon: <LockIcon />,
    menuTitle: "SBT Auths",
    title: `View Soul Bound Token authorisations`,
    component: <SbtAuthDashboard />,
    route: "sbt-auths",
  },
  {
    icon: <EnhancedEncryptionIcon />,
    menuTitle: "Create SBT Auths",
    title: `Create Soul Bound Token permissions`,
    component: <CreateSbtAuthDashboard />,
    route: "sbt-create-auth",
  },
  {
    icon: <AddShoppingCartIcon />,
    menuTitle: "Marketplace list",
    title: "List SBTs on a marketplace",
    component: <MarketplaceListDashboard />,
    route: "marketplace-list"
  },
  {
    icon: <ShoppingCartCheckoutIcon />,
    menuTitle: "Marketplace listings",
    title: "Make offers on marketplace listings",
    component: <MarketplaceOfferDashboard />,
    route: "marketplace-offer"
  },
  {
    icon: <LocalGroceryStoreIcon />,
    menuTitle: "Accept offers",
    title: "Accept marketplace offers",
    component: <MarketplaceGrantDashboard />,
    route: "marketplace-grant"
  }
];

const MenuItemButton = ({ item }) => {
  const nav = useNavigate();
  return (
    <ListItemButton onClick={() => nav(`/${item.route}`)}>
      <ListItemIcon>{item.icon}</ListItemIcon>
      <ListItemText primary={item.menuTitle} />
    </ListItemButton>
  );
};

function App() {
  const { useMainnet } = useEnv();
  const near = useNear();

  const element = useRoutes([
    ...listItems.map((item) => ({
      path: item.route + "/*",
      element: (
        <Dashboard
          title={item.title}
          useMainnet={useMainnet}
          listItems={listItems.map((item) => (
            <MenuItemButton item={item} />
          ))}
        >
          {item.component}
        </Dashboard>
      ),
    })),
    {
      path: "*",
      element: <Navigate to={listItems[0].route} replace />,
    },
  ]);

  if (!near.account.account) {
    return (
      <Dashboard
        title={"Sign in to use dashboard"}
        useMainnet={useMainnet}
        listItems={listItems.map((item) => (
          <MenuItemButton item={item} />
        ))}
      ></Dashboard>
    );
  }

  return element;
}

export default App;
